import React from "react";
import { Route, Routes } from "react-router-dom";
import { RootLayout } from "./components/Layout";
import Home from "./modules/home";
import MentionsLegales from "./pages/legal/MentionsLegales";
import PolitiqueConfidentialite from "./pages/legal/PolitiqueConfidentialite";
import PolitiqueCookies from "./pages/legal/PolitiqueCookies";

const App = () => {
  return (
    <RootLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route
          path="/politique-confidentialite"
          element={<PolitiqueConfidentialite />}
        />
        <Route path="/politique-cookies" element={<PolitiqueCookies />} />
      </Routes>
    </RootLayout>
  );
};

export default App;

// https://www.youtube.com/watch?v=I2NNxr3WPDo https://www.youtube.com/watch?v=SMYsxHwsExQ
